import React from "react";
import Navbar from "./Navbar"; // Assuming you already have a Navbar component
import Footer from "./Footer";

const AboutUs = () => {
    return (
        <>
            <Navbar />
            <div className="bg-[#0a0a0a] min-h-screen py-16 pt-36">
                <div className="container mx-auto px-4 md:px-12 text-white">
                    <h1 className="text-4xl font-bold text-center mb-8">About Nanahana</h1>

                    <p className="text-lg leading-7 mb-6 text-gray-300">
                        Welcome to <span className="font-semibold text-white">Nanahana</span>, your go-to destination for trendy and high-quality clothing!
                        At Nanahana, we believe that fashion is more than just clothing—it's an expression of individuality, personality, and creativity.
                    </p>

                    <h2 className="text-3xl font-semibold mb-4">Who We Are</h2>
                    <p className="text-lg leading-7 mb-6 text-gray-300">
                        Nanahana is an e-commerce platform dedicated to bringing you the best in fashion, with a wide range of stylish clothing for every occasion.
                        Our collection is curated with an eye for quality, style, and affordability, ensuring that you always look your best without breaking the bank.
                    </p>

                    <h2 className="text-3xl font-semibold mb-4">Our Mission</h2>
                    <p className="text-lg leading-7 mb-6 text-gray-300">
                        Our mission is simple: to make fashion accessible to everyone. Whether you're looking for the perfect outfit for a casual day out or a special event,
                        we’ve got you covered. We strive to offer a seamless shopping experience, with a focus on customer satisfaction and convenience.
                    </p>

                    <h2 className="text-3xl font-semibold mb-4">Why Nanahana?</h2>
                    <ul className="list-disc list-inside space-y-2 text-lg leading-7 text-gray-300">
                        <li>Trendy Collections: Stay ahead of the latest fashion trends with our handpicked collections.</li>
                        <li>Affordable Pricing: Look stylish without spending a fortune.</li>
                        <li>Quality You Can Trust: We offer clothing that not only looks great but also lasts.</li>
                        <li>Exceptional Service: Our customer service team is here to ensure your shopping experience is smooth and enjoyable.</li>
                    </ul>

                    <h2 className="text-3xl font-semibold mt-8 mb-4">Our Values</h2>
                    <ul className="list-disc list-inside space-y-2 text-lg leading-7 text-gray-300">
                        <li>Inclusivity: Fashion is for everyone. We offer sizes and styles that cater to a wide range of body types and personal preferences.</li>
                        <li>Sustainability: We are committed to sustainable practices in our sourcing and manufacturing processes.</li>
                        <li>Innovation: We constantly evolve to bring you the latest styles while improving your shopping experience.</li>
                    </ul>

                    <h2 className="text-3xl font-semibold mt-8 mb-4">Join the Nanahana Family!</h2>
                    <p className="text-lg leading-7 mb-6 text-gray-300">
                        At Nanahana, fashion is more than just clothes—it’s a lifestyle. We invite you to explore our collections, express yourself, and be part of a community that
                        values individuality and creativity.
                    </p>

                    <p className="text-lg leading-7 text-gray-300">
                        Stay connected with us on social media and be the first to know about new arrivals, exclusive offers, and fashion tips!
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default AboutUs;
